import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-eb527eec"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "hero-power-container"
};
const _hoisted_2 = {
  key: 0,
  class: "hero-power-content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title van-hairline--bottom animate__animated animate__fadeIn"
}, [/*#__PURE__*/_createElementVNode("span", null, "区服"), /*#__PURE__*/_createElementVNode("span", null, "地区(省/市/区标)"), /*#__PURE__*/_createElementVNode("span", null, "分数")], -1));

const _hoisted_4 = {
  key: 0,
  class: "dctype"
};
const _hoisted_5 = {
  class: "district"
};
const _hoisted_6 = {
  class: "district"
};
const _hoisted_7 = {
  class: "district"
};
const _hoisted_8 = {
  key: 1,
  class: "loading"
};
import { useRoute } from "vue-router";
import { ref } from "vue";
import { reqHeroPowerAqq, reqHeroPowerAwx, reqHeroPowerIqq, reqHeroPowerIwx } from "@/api";
import { searchthemeVars } from "@/ui_option";
export default {
  __name: 'index',

  setup(__props) {
    const route = useRoute();
    const heroName = route.query.heroName;
    const heroPowerData = ref([]);
    const dctype = ["安卓QQ", "安卓WX", "苹果QQ", "苹果WX"];
    const errStatus = ref(null);

    async function getHeroPowerData() {
      try {
        errStatus.value = null;
        const data = await Promise.all([reqHeroPowerAqq({
          heroName
        }), reqHeroPowerAwx({
          heroName
        }), reqHeroPowerIqq({
          heroName
        }), reqHeroPowerIwx({
          heroName
        })]);
        heroPowerData.value = data;
      } catch (error) {
        errStatus.value = error;
        console.log("search-err-msg ------", error);
      }
    }

    getHeroPowerData();
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");

      const _component_van_loading = _resolveComponent("van-loading");

      const _component_van_empty = _resolveComponent("van-empty");

      const _component_van_config_provider = _resolveComponent("van-config-provider");

      return _openBlock(), _createBlock(_component_van_config_provider, {
        "theme-vars": _unref(searchthemeVars),
        style: {
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", null, [_createVNode(_component_van_icon, {
          name: "arrow-left",
          class: "ico",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back())
        })]), heroPowerData.value && heroPowerData.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(heroPowerData.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: item.name,
            class: _normalizeClass(`hero-power${index + 1} animate__animated animate__fadeInLeft ${index === heroPowerData.value.length - 1 ? '' : 'van-hairline--bottom'}`)
          }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(dctype, (type, tyIndex) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: type
            }, [index == tyIndex ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(type), 1)) : _createCommentVNode("", true)], 64);
          }), 64)), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(item.province), 1), _createElementVNode("span", null, _toDisplayString(item.provincePower), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(item.city), 1), _createElementVNode("span", null, _toDisplayString(item.cityPower), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.area), 1), _createElementVNode("span", null, _toDisplayString(item.areaPower), 1)])], 2);
        }), 128))])) : _createCommentVNode("", true), !heroPowerData.value.length && errStatus.value == null ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_van_loading, {
          type: "spinner",
          color: "#fff"
        })])) : _createCommentVNode("", true), errStatus.value ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "err-wrapper",
          onClick: getHeroPowerData
        }, [_createVNode(_component_van_empty, {
          image: "error",
          "image-size": "100",
          description: "数据加载失败, 点击重新尝试 !",
          style: {
            "color": "white"
          }
        })])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["theme-vars"]);
    };
  }

};